import e from "react";
import { getIconColor as a } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const i = {
  display: "block"
}, E = ({ size: t = 16, useVw: c, useRem: n, color: r, withColor: l, removeClassName: m, disableSSR: f, style: o, ...d }) => {
  const p = o ? { ...i, ...o } : i;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: f }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "telegram-24px", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), height: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), className: m ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#1258e9__a)"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: l ? a(r, 0, "currentColor") : "currentColor",
        datafollowfill: l ? a(r, 0, "currentColor") : "currentColor",
        d: "M23.933 3.82 20.31 20.794c-.273 1.198-.986 1.496-1.999.931l-5.518-4.04-2.663 2.544c-.294.293-.54.538-1.109.538l.397-5.584 10.227-9.184c.445-.394-.096-.612-.69-.218L6.31 13.69.868 11.999c-1.184-.367-1.205-1.177.246-1.74l21.292-8.151c.986-.368 1.848.218 1.527 1.714Z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258e9__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: l ? a(r, 1, "#fff") : "#fff",
        d: "M0 0h24v24H0z"
      }
    )
  )));
}, h = E;
export {
  h as default
};
